'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _documents = require('./documents');

var _documents2 = _interopRequireDefault(_documents);

var _document = require('./document');

var _document2 = _interopRequireDefault(_document);

var _schoollevels = require('./schoollevels');

var _schoollevels2 = _interopRequireDefault(_schoollevels);

var _chapter = require('./chapter');

var _chapter2 = _interopRequireDefault(_chapter);

var _synchronization = require('./synchronization');

var _synchronization2 = _interopRequireDefault(_synchronization);

var _copy = require('./copy');

var _copy2 = _interopRequireDefault(_copy);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxAsyncConnect.reducer,
  auth: _auth2.default,
  documents: _documents2.default,
  document: _document2.default,
  schoolLevels: _schoollevels2.default,
  chapter: _chapter2.default,
  synchronization: _synchronization2.default,
  copy: _copy2.default,
  config: _config2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 1200
// module chunks = 0